import React from 'react';

const Functional = () => {
	return (
		<div>This is a functional component</div>
	)
}

export default Functional;


// WEBPACK FOOTER //
// ./src/components/Functional.js